import { useTranslations } from "use-intl";
import { Button } from "@/components/catalyst/button";
import { useLocalStorage } from "@/lib/Hooks/useLocalStorage";
import { localStorageKeys } from "@/lib/utils";

export function TripDefaultsPromptNotice() {
  const t = useTranslations("settings.offices.trips.defaultsPrompt");
  const [isSkipped, , enable] = useLocalStorage<boolean>(
    localStorageKeys.SKIP_TRIP_DEFAULTS_PROMPT,
  );

  return isSkipped ? (
    <div className="flex w-full items-center justify-between gap-4 rounded-lg bg-zinc-50 px-4 py-3 text-sm text-zinc-600 dark:bg-zinc-800 dark:text-zinc-400">
      <span>{t("disabled")}</span>
      <Button outline onClick={enable}>
        {t("enable")}
      </Button>
    </div>
  ) : null;
}
